import { z } from 'zod';
import { Block, BlockSchema } from './Block.types';

import { BlockType, TestimonialBlockConfigSchema } from './blockConfig/Types';

export const TestimonialBlockSchema = BlockSchema.extend({
  blockConfig: TestimonialBlockConfigSchema,
});

export type TestimonialBlock = z.infer<typeof TestimonialBlockSchema>;

export function isTestimonialBlock(block: Block): block is TestimonialBlock {
  return block.blockConfig.type === BlockType.Testimonial;
}
